import * as React from 'react';
//@ts-ignore
import Countdown, { zeroPad } from 'react-countdown';
import {sessionExpire} from './MonCompteAction';

//@ts-nocheck
import Icons from './Icons';

//@ts-ignore
import ReactTooltip from 'react-tooltip';

//@ts-ignore
import moment from "moment";
import axios from "axios";
import {getHostApi, getRequestConfig} from "../../utils";

export function getDecalageVariable() {
  return axios.get(`${getHostApi()}/shops/features/compte_decalage_commande`, getRequestConfig());
}

export default class RenderCountdown extends React.Component<any, any> {

  constructor(props: any) {
    super(props);

    this.state = {
      validationBAT: moment(this.props.infosCompteur.validationBAT),
      envoiFichier: moment(this.props.infosCompteur.envoiFichier),
      dateLivraisonPrevue: moment(this.props.infosCompteur.dateLivraison),
    };
    this.incrementeDate = this.incrementeDate.bind(this);

    this.featureDecalage();

    if (this.props.type == 'BAT') {
      if (moment(this.props.infosCompteur.validationBAT) < moment() && this.props.onChangeDateLivraison != false) {
        this.state = {
          validationBAT: moment(this.props.infosCompteur.validationBATSiDecalage),
          envoiFichier: moment(this.props.infosCompteur.envoiFichierSiDecalage),
          dateLivraisonPrevue: moment(this.props.infosCompteur.dateLivraisonSiDecalage),
        };
        this.props.onChangeDateLivraison(this.state.dateLivraisonPrevue.format('YYYY-MM-DD'));
      }
    } else {
      if (moment(this.props.infosCompteur.envoiFichier) < moment() && this.props.onChangeDateLivraison != false) {
        this.state = {
          validationBAT: moment(this.props.infosCompteur.validationBATSiDecalage),
          envoiFichier: moment(this.props.infosCompteur.envoiFichierSiDecalage),
          dateLivraisonPrevue: moment(this.props.infosCompteur.dateLivraisonSiDecalage),
        };
        this.props.onChangeDateLivraison(this.state.dateLivraisonPrevue.format('YYYY-MM-DD'));
      }
    }
  }

  getMessageTooltip(type: string) {
    let msg = '';
    const supp = `<br/> pour une livraison estimée au ${this.state.dateLivraisonPrevue.format('dddd DD MMMM')}.</p><p class='lightgrey font-italic m-0 text-center'>Au delà de cette échéance,<br/> la date de livraison sera automatiquement décalée d'un jour ouvré</p>`;
    if (type == 'BAT') {
      msg = `<p class="text-center">Acceptez votre BAT avant ${this.state.validationBAT.format('dddd DD MMMM HH:mm')}` + supp;
      return msg;
    }
    if (type == 'Fichier') {
      msg = `<p class="text-center">Validez l'envoi de vos fichiers avant ${this.state.envoiFichier.format('dddd DD MMMM HH:mm')}` + supp;
      return msg;
    }
  }

  incrementeDate() {
    this.setState({
      validationBAT: moment(this.props.infosCompteur.validationBATSiDecalage),
      envoiFichier: moment(this.props.infosCompteur.envoiFichierSiDecalage),
      dateLivraisonPrevue: moment(this.props.infosCompteur.dateLivraisonSiDecalage),
    }, this.props.onChangeDateLivraison(this.state.dateLivraisonPrevue.format('YYYY-MM-DD')));
  }

  featureDecalage() {
    getDecalageVariable().then((response) => {
      if (response.data.feature) {
        this.setState({ activateDecalage: response.data.feature });
      }
    }).catch((error) => {
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  render() {
    const renderer = ({ days, hours, minutes, seconds, completed }: {days: any, hours: any, minutes: any, seconds: any, completed: any}) => {
      const dayss = zeroPad(days);
      const hourss = zeroPad(hours);
      const minutess = zeroPad(minutes);
      const secondes = zeroPad(seconds);
      const days1 = dayss.substr(0,1);
      const days2 = dayss.substr(1,1);
      const hours1 = hourss.substr(0,1);
      const hours2 = hourss.substr(1,1);
      const minutes1 = minutess.substr(0,1);
      const minutes2 = minutess.substr(1,1);
      const sec1 = secondes.substr(0,1);
      const sec2 = secondes.substr(1,1);

      const strJour = days > 1 ? 'Jours' : 'Jour';
      const strHeure = hours > 1 ? 'Heures' : 'Heure';
      const nbrCol = days >= 1 ? 8 : 6;
      return (
          <table className={'tableCountdown black bold text-center  position-relative'}>
            <tbody>
              <tr className={'tableCountdownBorder position-relative'}>
                <td colSpan={nbrCol}>&nbsp;</td>
              </tr>
              <tr>
                {days >= 1 &&
                  <>
                    <td className={'tdTableCountdownTime'}><span>{days1}</span><span>{days2}</span></td>
                    <td><span className={'tdTableCountdownTimeSeparator'}>:</span></td>
                </>
                }
                <td className={'tdTableCountdownTime'}><span>{hours1}</span><span>{hours2}</span></td>
                <td><span className={'tdTableCountdownTimeSeparator'}>:</span></td>
                <td className={'tdTableCountdownTime'}><span>{minutes1}</span><span>{minutes2}</span></td>
                <td><span className={'tdTableCountdownTimeSeparator'}>:</span></td>
                <td className={'tdTableCountdownTime'}><span>{sec1}</span><span>{sec2}</span></td>
                <td><div className={''}><Icons icon={'info'} size={20} color={'#f68909'}/></div></td>
              </tr>
              <tr className={'tableCountdownLegend'}>
                {days >= 1 &&
                  <>
                    <td className={'w25Percent'}>{strJour}</td>
                    <td/>
                  </>
                }
                <td className={'w25Percent'}>{strHeure}</td>
                <td/>
                <td className={'w25Percent'}>Min.</td>
                <td/>
                <td className={'w25Percent'}>Sec.</td>
                <td/>
              </tr>
            </tbody>
          </table>);

    };
    return (
      <>
        {this.state.activateDecalage && this.props.infosCompteur && this.props.infosCompteur.validationBAT && <div data-tip={this.getMessageTooltip(this.props.type)} data-for={this.props.idCommande + "-tooltip"} className={`font8`}>
          <Countdown date={new Date(this.props.type == "BAT" ? this.state.validationBAT : this.state.envoiFichier)} renderer={renderer}
                     onComplete={this.incrementeDate} overtime={true}/>
          <ReactTooltip   id={this.props.idCommande + "-tooltip"} effect={'solid'} place={this.props.orderline ? undefined : 'bottom'} html={true}/>
        </div>}
      </>
    );
  }
}
